import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Modal } from 'components/layout/Modal/Modal'

const StyledModal = styled(Modal)`
  ${({ theme }) => css`
    & .MuiPaper-root {
      min-width: 650px;
      max-height: 700px;

      height: 700px;
      display: flex;
      flex-direction: column;

      ${theme.breakpoints.down('sm')} {
        min-width: 100px;
      }
    }
  `}
`

const StyledModalContent = styled(Modal.Content)`
  flex-grow: 1;
  overflow: auto;
`

export {
  StyledModal as Modal,
  StyledModalContent as ModalContent,
}
